import { Button, message } from "antd";
import AppApi from "api/App/AppApi";
import AppConstants from "global/constants/AppConstants";
import { Result } from "global/constants/AppType";
import { useAuth } from "global/context/AuthenticationContext";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface ResultModalProps {
  info: any;
  onClose: () => void;
}

const ResultModal: React.FC<ResultModalProps> = ({ info, onClose }) => {
  const navigate = useNavigate();
  const { getUserInfo } = useAuth();

  const [resultObject, setResultObject] = useState<Result | null>(null);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState<number>(0);

  const onConfirm = async () => {
    try {
      setLoading(true);

      const values = {
        planId: info?.plan_id,
        serial: info?.serial,
        simType: info?.sim_type,
      };

      const response = await AppApi.simKitPickPackage(info?.id, values);

      if (response?.data) {
        setStep(1);
        getUserInfo();
      } else {
        setResultObject({
          type: "error",
          message: response?.message || AppConstants.ERROR_OCCUR,
        });
        onClose();
      }
    } catch (error) {
      console.log(error);
      setResultObject({
        type: "error",
        message: AppConstants.ERROR_OCCUR,
      });
    } finally {
      setLoading(false);
    }
  };

  const onNav = async () => {
    message.info("Bạn đang chuyển hướng tới trang giỏ hàng...");
    onClose();
    navigate("/shopping-cart/number-cart-page");
  };

  useEffect(() => {
    if (!!resultObject?.message) {
      switch (resultObject?.type) {
        case "success":
          message.success(resultObject?.message);
          break;
        case "error":
          message.error(resultObject?.message);
          break;
        default:
          break;
      }
    }
  }, [resultObject]);

  if (loading) {
    return (
      <div className="text-center">
        <div className="text-[19px] font-bold">Chờ xử lý</div>
        <div className="mt-2 text-[16px] font-normal italic">
          Đơn hàng của quý khách đang chờ xử lý
        </div>
      </div>
    );
  }

  return (
    <>
      {step === 0 ? (
        <>
          <div className="text-center">
            <div className="text-[19px] font-bold">Xác nhận</div>
            <div className="mt-2 text-[16px] font-normal italic">
              {"Bạn có chắc chắn muốn chọn số"} {info?.phoneNumber}
              {" với gói cước"} {info?.selectedPlan?.name}
            </div>
          </div>
          <div className="mt-[10px] w-full flex justify-center gap-x-2">
            <Button
              type="default"
              className="btn_color btn_P w-[45%] text-[16px]"
              style={{ height: 30, margin: "0px 2px" }}
              onClick={onClose}
            >
              {"Đóng"}
            </Button>
            <Button
              type="default"
              className="btn_color btn_P1 w-[45%] text-[16px]"
              style={{ height: 30, margin: "0px 2px" }}
              onClick={onConfirm}
            >
              {"Xác nhận"}
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className="text-center">
            <div className="text-[19px] font-bold">Đơn chọn số</div>
            <div className="mt-2 text-[16px] font-normal italic">
              Đơn hàng của quý khách đã thành công
            </div>
          </div>
          <div className="mt-[10px] w-full">
            <Button
              type="default"
              className="btn_color btn_P1 w-full text-[16px]"
              style={{ height: 30, margin: "0px 2px" }}
              onClick={onNav}
            >
              {"Xác nhận"}
            </Button>
          </div>
        </>
      )}
    </>
  );
};

export default ResultModal;
